import { useContext } from "react"
import { LanguageContext } from "../App"
import manualPDF from '../util/manuals/SmartDetector_manuel.pdf';
import manualPDF_en from '../util/manuals/SmartDetector_manuel_en.pdf';
import selectedImage from '../util/images/SM2.gif';

const exportManuel = (lang)=>{
            const a = document.createElement('a');
            if (lang==='Manuel Utilisateur'){
                a.href = manualPDF;
                a.download = 'SmartDetector_manuel.pdf';
                }
            else if (lang==='User Manual'){
                a.href = manualPDF_en;
                a.download = 'SmartDetector_manual.pdf';
                }
            else {
                a.href = manualPDF_en;
                a.download = 'SmartDetector_manual.pdf';
                }
            //a.href = URL.createObjectURL(a.download);
            a.textContent = 'download the manual';
            a.click()
        }

const Home = () =>{

  const language = useContext(LanguageContext)

    return (
        <>
          <div className="px-5">
            <h1 className="mt-5">{language.main.p1.h}</h1>
            <p>{language.main.p1.p}</p>
          </div>
          <div className="text-center my-3">
                <img src={selectedImage} alt="Selected Option" style={{ width: '500px' }} />
            </div>
          <hr />
          <div className="row mt-5">
              <div className="col-sm-6 col-12 px-5">
                <h1> <a href="./animator"> {language.main.p2.h}</a> </h1>
                <p>{language.main.p2.p}</p>
              </div>
              <div className="col-sm-6 col-12 px-5">
                <h1>  <a href="./detectors"> {language.main.p3.h}</a> </h1>
                <p>{language.main.p3.p}</p>
	        
                <button className='btn btn-dark' onClick={() => exportManuel(language.main.p4.h)}>{language.main.p4.h}</button>
              </div>
          </div>
        </>
    )
}

export default Home
